import classNames from 'classnames';
import { Trans } from 'react-i18next';

import { AlertInfoIcon, Button, Tooltip } from '@ctct/payflow-ui';

import type { OrderItemProps } from '../types';

export const SingleOrderItem = ({
  id,
  variant,
  mainLabel,
  secondaryLabels,
  discountLabel,
  priceLabel,
  discountPriceLabel,
  buttons,
  tooltipI18nKey,
}: OrderItemProps) => (
  <div
    className={classNames(
      'order-summary-container__order-items_item',
      variant === 'overdue' && 'overdue',
      tooltipI18nKey && 'with-tooltip'
    )}
  >
    <div className="order-items__rows-container">
      <div className="order-items__content">
        {tooltipI18nKey ? (
          <Tooltip content={<Trans i18nKey={tooltipI18nKey} />} variant="dark" hideArrow>
            <AlertInfoIcon />
          </Tooltip>
        ) : null}
        <p className="order-items__content_main-label">
          {variant === 'bold' ? <strong>{mainLabel}</strong> : mainLabel}
        </p>

        {secondaryLabels.map((label) => (
          <p key={label} className="order-items__content_secondary-label">
            {label}
          </p>
        ))}

        {discountLabel && <p className="order-items__content_discount-label">{discountLabel}</p>}
      </div>

      <div className="order-items__price">
        <p className="order-items__price_label">{priceLabel}</p>
        {discountPriceLabel && <p className="order-items__discount-price_label">{discountPriceLabel}</p>}
      </div>
    </div>
    {buttons && buttons.length > 0 && (
      <div className="order-items__content_buttons-container">
        {buttons.map((btn) => (
          <Button key={btn.label} variant="text" size="xs" onClick={() => btn.onClick(id)} disabled={btn.disabled}>
            {btn.label}
          </Button>
        ))}
      </div>
    )}
  </div>
);
